// src/components/LoadingState.jsx
import React from 'react';

const MESSAGES = [
  'Rifling through your fridge…',
  'Consulting the recipe archives…',
  'Finding your best matches…',
  'Almost there…',
];

export default function LoadingState() {
  const [msgIdx] = React.useState(() => Math.floor(Math.random() * MESSAGES.length));

  return (
    <div style={styles.wrap}>
      <div style={styles.spinnerRing}>
        <div style={styles.spinner} />
      </div>
      <p style={styles.msg}>{MESSAGES[msgIdx]}</p>
      <div style={styles.dots}>
        {[0, 1, 2].map(i => (
          <span key={i} style={{ ...styles.dot, animationDelay: `${i * 0.2}s` }} />
        ))}
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '80px 32px',
    textAlign: 'center',
    animation: 'fadeUp 0.3s ease',
  },
  spinnerRing: {
    width: '48px',
    height: '48px',
    position: 'relative',
    marginBottom: '20px',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '3px solid var(--border-base)',
    borderTopColor: 'var(--accent-orange)',
    borderRadius: '50%',
    animation: 'spin 0.85s linear infinite',
  },
  msg: {
    fontSize: '14.5px',
    color: 'var(--text-muted)',
    fontStyle: 'italic',
    marginBottom: '14px',
    transition: 'color 0.3s ease',
  },
  dots: {
    display: 'flex',
    gap: '5px',
  },
  dot: {
    width: '6px',
    height: '6px',
    borderRadius: '50%',
    background: 'var(--border-strong)',
    animation: 'pulse 1.2s ease infinite',
  },
};
